// Strong-password helpers: a generator (crypto-random, no ambiguous chars) and
// a lightweight strength scorer for the meter on register / reset.

const UP = 'ABCDEFGHJKLMNPQRSTUVWXYZ';   // no I, O
const LO = 'abcdefghijkmnpqrstuvwxyz';   // no l
const DI = '23456789';                   // no 0, 1
const SY = '!@#$%&*?-_';

function randInt(max: number): number {
  return Math.floor((crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32) * max);
}
function pick(set: string): string {
  return set[randInt(set.length)];
}

/** A strong, readable password with at least one of each class. */
export function suggestPassword(len = 16): string {
  const all = UP + LO + DI + SY;
  const chars = [pick(UP), pick(LO), pick(DI), pick(SY)];
  while (chars.length < len) chars.push(pick(all));
  for (let i = chars.length - 1; i > 0; i--) {   // Fisher–Yates shuffle
    const j = randInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

export interface Strength { score: number; label: string; cls: string }

/** 0–4 strength heuristic for the meter. */
export function scoreStrength(pw: string): Strength {
  if (!pw) return { score: 0, label: '', cls: 'bg-[var(--color-border)]' };
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  s = Math.min(4, s);
  const labels = ['Very weak', 'Weak', 'Fair', 'Good', 'Strong'];
  const clss = ['bg-[var(--color-danger-fg)]', 'bg-[var(--color-danger-fg)]', 'bg-[var(--color-warning-fg)]', 'bg-[var(--color-success-fg)]', 'bg-[var(--color-success-fg)]'];
  return { score: s, label: labels[s], cls: clss[s] };
}
